export default __webpack_public_path__ + "94bb4cbf486a92c6f1ff9fdae7c14080.png";